<template>
    <div class="authTop text-center">
        <h3 class="heading">{{ heading }}</h3>
        <p class="text">{{ text }}</p>
    </div>
</template>

<script>
export default {
    props: {
        heading: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="postcss" scoped>
.authTop {
    margin-bottom: 25px;
    padding: 0 50px;
}
.heading {
    margin-bottom: 10px;
}
.text {
    font-size: 15px;
}
</style>
